<lib-card
	[title]="'Foods preview'"
	[subtitle]="'There are tens of thousands of foods imported from the official USDA database'"
>
	<div>
		<lib-search-input [debounceTime]="30" (search)="handleAzureSeach($event)"> </lib-search-input>
	</div>
	<div class="push-top-md">
		@if (azureSearchItemsLoaded()) {
		<lib-list
			[enableSearch]="false"
			(selectItem)="handleSelectAzureSearchItem($event)"
			[design]="'selectionList'"
			[showNameBasedAvatar]="false"
			[items]="azureSearchItems()"
		></lib-list>
		}
	</div>
</lib-card>
